// mutations
const SET_RESBYID = (state, payload) => {
  state.res_byid = payload;
};
const SET_IDUSER = (state, payload) => {
  state.id_user = payload;
};
const SET_TEMPINPUT = (state, payload) => {
  state.temp_input = payload;
};
const SET_IDDATA = (state, payload) => {
  state.id_data = payload;
};
const SET_RES = (state, payload) => {
  state.res_data = payload;
};
const SET_RESEDIT = (state, payload) => {
  state.res_edit = payload;
};
export default {
  SET_RESBYID,
  SET_IDUSER,
  SET_TEMPINPUT,
  SET_IDDATA,
  SET_RES,
  SET_RESEDIT
};
